export const ADD_PERMISSIONS = 'ADD_PERMISSIONS'
export const ADD_PERMISSIONS_WITH_DATA = 'ADD_PERMISSIONS_WITH_DATA'
export const ADD_PERMISSION = 'ADD_PERMISSION'
